<template>
  <div class="col-md-8 cda-doc">
    <iframe class="iframe" :id="'cda-'+id" @load.stop='onCdaLoad' ref='frame'></iframe>
  </div>
</template>
<script>
  import * as srcDoc from 'srcdoc-polyfill';

  export default {
    name: 'cda-doc',
    props: {
      cdaDoc: {
        type: String,
        default: ''
      },
      id: {
        type: String,
        default: ''
      }
    },
    methods: {
      onCdaLoad() {
        if (!this.$refs.frame) {
          return;
        }
        let srcdocAttribute = this.$refs.frame.getAttribute('srcdoc');
        if(srcdocAttribute) {
          this.$emit('on-cda-load');
        }
        else {
        }
      }
    },
    watch: {
      cdaDoc: function(newCdaDoc) {
        if (newCdaDoc && typeof(newCdaDoc) != 'undefined') {
          srcDoc.set(document.getElementsByClassName('iframe')[0], newCdaDoc);
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  .iframe {
    width: 100%;
    height: 90vh;
    background-color: #fff;
    border: 1px solid lighten(#000, 70%);
  }
</style>

